import Axios from "axios";
import {
    SET_ASSET_LOCATION_LIST,
    UNSET_ASSET_LOCATION_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetLocation, getAssetLocationsList } from "@/store/api";

const state = {
    getAssetLocationsList: [],
};

const getters = {
    getAssetLocationsList(state) {
        return state.getAssetLocationsList;
    }
};

const mutations = {
    [SET_ASSET_LOCATION_LIST](state, data) {
        state.getAssetLocationsList = data;
    },
    [UNSET_ASSET_LOCATION_LIST](state) {
        state.getAssetLocationsList = [];
    }
};

const actions = {
    saveUpdateAssetLocation({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetLocation, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetLocationsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetLocationsList, data)
                .then(function (response) {
                    commit('SET_ASSET_LOCATION_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_LOCATION_LIST');
                    reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
